import React from 'react';
import FsLightbox from 'fslightbox-react';

const MediaLightbox = ({ src, toggler, type = 'image' }) => {
    if (!src) return null;
    return (
        <FsLightbox
            key={src}
            toggler={toggler}
            sources={[src]}
            types={[type]}
        />
    );
};

export default MediaLightbox;
